<article class="card compact-event-card overflow-hidden"
         [ngClass]="{
           'event-running': eventStatus === 'running',
           'event-closed': eventStatus === 'finished'
         }">
  <a class="image-link"
     [routerLink]="['/home', 'events', event.league, event.uuid]"
     [attr.aria-label]="event.event_name + ' öffnen'">
    <img [src]="event.image_content || 'assets/sf-logo-start-2022.png'"
         class="event-image"
         [alt]="event.event_name">
  </a>

  <div class="event-content card-body">
    <div class="event-meta">
      <span class="text-muted small">Langzeit-Tipp</span>
      <span class="badge rounded-pill" [ngClass]="{
        'text-bg-success': eventStatus === 'open',
        'text-bg-warning': eventStatus === 'running',
        'text-bg-secondary': eventStatus === 'finished'
      }">
        <i class="bi me-1" [ngClass]="eventStatus === 'open' ? 'bi-circle-fill' : 'bi-lock-fill'"></i>
        {{ eventStatusLabel }}
      </span>
    </div>

    <h3 class="event-title">{{ event.event_name }}</h3>
    <p class="description">{{ event.description }}</p>
    <p class="deadline">
      <i class="bi bi-calendar-event"></i>
      {{ eventStatus === 'running' ? 'Tippabgabe beendet am' : 'Tippabgabe bis' }}
      {{ event.deadline | spotfightDateFormat }}
    </p>
  </div>

  <a class="btn btn-primary btn-sm event-action"
     [routerLink]="['/home', 'events', event.league, event.uuid]">
    <span>{{ eventStatus === 'open' ? 'Jetzt tippen' : 'Ansehen' }}</span>
    <i class="bi bi-arrow-right"></i>
  </a>
</article>
